// extracted by mini-css-extract-plugin
export default {"AntApp":"App_AntApp__H3DIQ"};